// Source unique des catégories et sous-catégories du site.
// - value  : valeur enregistrée sur les produits (Product.category / Product.sub_category) — ne jamais la renommer.
// - label  : libellé affiché.
// - slug   : adresse visible dans l'URL (par défaut, la valeur technique).
// - kwisatz: code famille Kwisatz rempli automatiquement sur les fiches.

export const CATEGORIES = [
  {
    value: 'coffrets-circuits',
    label: 'Coffrets Circuits',
    kwisatz: 610,
    subs: [
      { value: 'coffret-digital', label: 'Coffret Digital' },
      { value: 'coffret-analogique', label: 'Coffret Analogique' },
    ],
  },
  {
    value: 'voitures',
    label: 'Voitures',
    kwisatz: 620,
    subs: [
      { value: 'dtm-tourisme', label: 'DTM / Tourisme' },
      { value: 'rallye-tout-terrain', label: 'Rallye / Tout-terrain' },
      { value: 'gt-gt3', label: 'GT / GT3' },
      { value: 'f1-monocoque', label: 'F1 / Monocoque' },
      { value: 'classic', label: 'Classic' },
      { value: 'muscle-car-americaine', label: 'Muscle car / Américaine' },
      { value: 'endurance-prototype', label: 'Endurance / Prototype' },
      { value: 'edition-limitees', label: 'Editions Limitées' },
      { value: 'autres', label: 'Autres' },
      { value: 'cinema-tv', label: 'Cinéma / TV' },
    ],
  },
  {
    value: 'equipements-accessoires',
    label: 'Accessoires',
    slug: 'accessoires',
    kwisatz: 635,
    subs: [
      { value: 'alimentations-power-base', label: 'Alimentations / Power Base' },
      { value: 'gestion-de-course', label: 'Gestion de course' },
      { value: 'controleurs-poignees', label: 'Contrôleurs / Poignées' },
      { value: 'puce-digital', label: 'Puce Digital' },
      { value: 'outils', label: 'Outils Slot' },
      { value: 'produits-maintenance', label: 'Produits / Maintenance' },
    ],
  },
  {
    value: 'equipements-rails',
    label: 'Rails',
    slug: 'rails',
    kwisatz: 615,
    subs: [
      { value: 'rail-digital', label: 'Rail Digital' },
      { value: 'rails-speciaux-analogiques', label: 'Rails Spéciaux Analogiques' },
      { value: 'droites-bordures', label: 'Droites / Bordures' },
      { value: 'courbes-r1-bordures', label: 'Courbes R1 / Bordures' },
      { value: 'courbes-r2-bordures', label: 'Courbes R2 / Bordures' },
      { value: 'courbes-r3-bordures', label: 'Courbes R3 / Bordures' },
      { value: 'courbes-r4-bordures', label: 'Courbes R4 / Bordures' },
      { value: 'rails-accessoires', label: 'Accessoires Rails', slug: 'accessoires-rails' },
      { value: 'packs-extension', label: "Packs d'extension" },
    ],
  },
  {
    value: 'pieces-detachees',
    label: 'Pièces détachées',
    kwisatz: 630,
    subs: [
      { value: 'tresses-guides-cables', label: 'Tresses / Guides / Câbles' },
      { value: 'moteurs-supports', label: 'Moteurs / Supports' },
      { value: 'pignons-couronnes', label: 'Pignons / Couronnes' },
      { value: 'pneus-jantes-axes', label: 'Pneus / Jantes / Axes' },
      { value: 'paliers-roulements-vis', label: 'Paliers / Roulements / Vis' },
      { value: 'aimants-lests', label: 'Aimants / Lests' },
      { value: 'chassis', label: 'Châssis' },
      { value: 'pieces-carrosseries', label: 'Pièces carrosseries' },
    ],
  },
  {
    value: 'decor',
    label: 'Décor',
    kwisatz: 625,
    subs: [
      { value: 'figurines', label: 'Figurines' },
      { value: 'batiments', label: 'Bâtiments' },
      { value: 'miniatures', label: 'Miniatures' },
    ],
  },
];

export const CATEGORY_VALUES = CATEGORIES.map(c => c.value);

const ALL_SUBS = CATEGORIES.flatMap(c => c.subs);

const findCategory = value => CATEGORIES.find(c => c.value === value);
const findSub = value => ALL_SUBS.find(s => s.value === value);

// Anciennes adresses conservées pour ne pas casser les liens déjà partagés
const LEGACY_SUB_SLUGS = {
  'rails-accessoires': 'rails-accessoires',
  'accessoires-circuit': 'rails-accessoires',
  'accessoires': 'rails-accessoires',
  'rails-circuit': '',
  'rails': '',
  'bordures-circuit': '',
  'bordures': '',
};

export function categoryLabel(value) {
  return findCategory(value)?.label || (value || '').replace(/-/g, ' ');
}

export function subCategoryLabel(value) {
  return findSub(value)?.label || (value || '').replace(/-/g, ' ');
}

// Valeur d'URL (français) d'une catégorie technique
export function categoryUrlSlug(value) {
  return findCategory(value)?.slug || value;
}

// Catégorie technique à partir du paramètre d'URL
export function categoryFromUrl(slug) {
  if (!slug) return 'all';
  return CATEGORIES.find(c => c.value === slug || c.slug === slug)?.value || slug;
}

export function subCategoryUrlSlug(value) {
  return findSub(value)?.slug || value;
}

export function subCategoryFromUrl(slug) {
  if (!slug) return '';
  if (slug in LEGACY_SUB_SLUGS) return LEGACY_SUB_SLUGS[slug];
  return ALL_SUBS.find(s => s.slug === slug)?.value || slug;
}

// Adresse boutique d'une catégorie, et éventuellement d'une sous-catégorie
export function categoryShopPath(categoryValue, subValue) {
  if (!categoryValue || categoryValue === 'all') return '/shop';
  const params = new URLSearchParams({ cat: categoryUrlSlug(categoryValue) });
  if (subValue) params.set('sub', subCategoryUrlSlug(subValue));
  return `/shop?${params.toString()}`;
}